import { render, staticRenderFns } from "./DepartmentUse.vue?vue&type=template&id=2992ba38&scoped=true"
import script from "./DepartmentUse.vue?vue&type=script&lang=js"
export * from "./DepartmentUse.vue?vue&type=script&lang=js"
import style0 from "./DepartmentUse.vue?vue&type=style&index=0&id=2992ba38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2992ba38",
  null
  
)

export default component.exports